import { createContext, useContext } from 'react';

export const ActionsContext = createContext();
export const useActions = () => useContext(ActionsContext);

export const ModalContext = createContext();
export const useModalProps = () => useContext(ModalContext);

export const ModalContentContext = createContext();
export const useModalContentProps = () => useContext(ModalContentContext);
